import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Assignor } from 'src/app/models/assignor';
import { Auth } from 'src/app/models/auth';
import { StatusValidation } from 'src/app/models/kyc';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CedenteService } from 'src/app/services/cedente.service';
import { KycService } from 'src/app/services/kyc.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-dado-empresa-info-cadastrais',
  templateUrl: './dado-empresa-info-cadastrais.component.html',
  styleUrls: ['./dado-empresa-info-cadastrais.component.scss']
})
export class DadoEmpresaInfoCadastraisComponent implements OnInit {

    constructor(
        private authenticationService: AuthenticationService,
        private alertService: NewAlertService,
        private router: Router,
        private route: ActivatedRoute,
        private cedenteService: CedenteService,
        private kycService: KycService
    ) { }

    private currentUser: Auth;
    public assignorInfo: Assignor;
    private kycStatusList: StatusValidation[];
    public emailStatus: StatusValidation;
    public phoneStatus: StatusValidation;
    public openingDateStatus: StatusValidation;

    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;
        this.getKycStatus();
        this.getAssignorInfo();
    }

    private getKycStatus() {
        this.kycService.statusList(this.currentUser.token.pessoaId)
            .subscribe(response => {
                if (response.status === ApiError.Sucesso) {
                    this.kycStatusList = response.result;
                    this.emailStatus = this.kycStatusList.find(e=>e.validationTypeId == 4);
                    this.phoneStatus = this.kycStatusList.find(e=>e.validationTypeId == 5);
                    this.openingDateStatus = this.kycStatusList.find(e=>e.validationTypeId == 6);
                } else {
                    this.alertService.warning(response.message);
                }
            })
    }

    private getAssignorInfo() {
        this.cedenteService.getAssignorInfo(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId)
            .subscribe(
                response => {
                    this.assignorInfo = response.result;

                    const tam = environment.TOTAL_CARACTERE_CNPJ - this.assignorInfo.document.toString().length;

                    let str = this.assignorInfo.document.toString();

                    for (let i = 0; i < tam; i++) { str = '0' + str; }
                        this.assignorInfo.document = str;

                    localStorage.setItem('assignorInfo', JSON.stringify(this.assignorInfo));
                }, error => {
                    this.alertService.error('Ocorreu um erro ao consultar as informações da empresa. Tente novamente mais tarde');
                }
            );
    }


    public normalize(phone) {
        if (phone == null)
            return phone;
        //normalize string and remove all unnecessary characters
        phone = phone.replace(/[^\d]/g, "");

        //check if number length equals to 10
        if (phone.length <= 10) {
            //reformat and return phone number
            return phone.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
        }else if (phone.length > 10) {
            //reformat and return phone number
            return phone.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
        }

        return "null";
    }


}
